export default __webpack_public_path__ + "static/dw-a9698bef10725c4fb6cf67962ff66edf.png";